/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BaseChartWidgetConfigurationModel extends models.BaseDataWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("BaseChartWidgetConfigurationModel");
    }

    getFixupPrototypeFunction() { return BaseChartWidgetConfigurationModel.fixupPrototype; }

    static newInstance(model: Partial<BaseChartWidgetConfigurationModel>): BaseChartWidgetConfigurationModel {
        let obj = Object.assign(new BaseChartWidgetConfigurationModel(), model);
        BaseChartWidgetConfigurationModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BaseChartWidgetConfigurationModel>): BaseChartWidgetConfigurationModel {
        if (!model) return null;
        return BaseChartWidgetConfigurationModel.newInstance(<BaseChartWidgetConfigurationModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BaseChartWidgetConfigurationModel) {
        if (!obj) return;

        models.BaseChartWidgetConfigurationModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BaseChartWidgetConfigurationModel): boolean {
        if (models.BaseDataWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BaseChartWidgetConfigurationModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.legendDisplayConfiguration) {
            models.LegendDisplayConfiguration.fixupPrototype(this.legendDisplayConfiguration);
        }
    }

    /**
     * Chart type to display data
     */
    chartType: models.ChartType;

    /**
     * Limit the amount of data to display
     */
    chartLimit: models.ChartLimit;

    legendDisplayConfiguration: models.LegendDisplayConfiguration;

}
